import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { EmitMetric } from '../../Analytics/VisibilityPixel/VisibilityPixel';

import './SocialShareBar.scss';
import {
    CommunityContext,
    PageContext,
} from '../../../contexts/ContextCreator';

const SocialShareBar = ({ hash, type, location }) => {
    const {
        pageProps: { url },
    } = useContext(PageContext);
    const { getContent } = useContext(CommunityContext);
    const content = getContent(hash);
    let urlToShare = `https://${url?.host}${content.contentUrl}`;
    const isEditorialContentOrPodcast = content.type === 'editorial-content';
    if (isEditorialContentOrPodcast) {
        urlToShare = content.contentUrl;
    }
    const handleOnClickMetricEmit = (event) => {
        EmitMetric({
            community_content_key: `${type}-${hash}`,
            community_content_location: location,
            share_destination: event.data.service,
            misc_event_type: 'social-bar-share',
            share: 1,
        });
    };

    useEffect(() => {
        window.addthis_share = {
            url: urlToShare,
            url_transforms: {
                add: {
                    utm_source: '{{code}}',
                    utm_medium: 'content-share',
                },
            },
        };
        const script = window.document.createElement('script');
        script.src = `//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5f110312a74b77dd`;
        script.id = 'addthis-script';
        script.async = true;
        document.head.appendChild(script);

        script.onload = () => {
            window.addthis.init();
            window.addthis.addEventListener(
                'addthis.menu.share',
                handleOnClickMetricEmit
            );
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="component-SocialShareBar">
            <div className="addthis_inline_share_toolbox_bg7s" />
        </div>
    );
};

SocialShareBar.propTypes = {
    hash: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
};

SocialShareBar.defaultProps = {};

SocialShareBar.displayName = 'SocialShareBar';

export default SocialShareBar;
